var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(("h" + (_vm.data.level)),{tag:"component",staticClass:"custom-title",class:("has-text-weight-bold is-size-" + (_vm.data.level + 1))},[_vm._v(" "+_vm._s(_vm.formattedText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }